import api from "../api";
import { API_URL } from "../constants";

export type UpdateProjectPayload = {
  name?: string;
  rootDirectory?: string;
  buildCommand?: string;
  installCommand?: string;
  buildOutDir?: string;
  port?: number;
  deployType?: string;
  autoDeployEnabled?: boolean;
};

export const getProject = (id: string) => {
  return api.get(`${API_URL}/v1/project/${id}`);
};

export const updateProject = (id: string, payload: UpdateProjectPayload) => {
  return api.patch(`${API_URL}/v1/project/${id}`, payload);
};
